import { Col, Container, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { REGEX } from "../../utils/utils";
import { useProductForm } from "../productModalForm";

const defaultValues = {
  shelfLifeDays: "",
  maxDispatchDays: "",
};

export const ShelfLifeForm = () => {
  const { disabled } = useProductForm();

  const {
    register,
    formState: { errors },
    watch
  } = useFormContext({
    defaultValues: defaultValues,
  });

  const shelfLifeDays = watch("shelfLifeDays");

  return (
    <Container>
      <h4>Vida útil</h4>
      <hr />
      <Row>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="shelfLifeDays" className="form-label">
            Vida útil
          </label>
          <input
            {...register("shelfLifeDays", {
              pattern: {
                value: REGEX.NUMERIC,
                message: "Ingrese un número válido",
              },
              validate: (value) => {
                if (!value) return true;
                return Number(value) > 0 || "El valor debe ser mayor que 0"
              },
            })}
            id="shelfLifeDays"
            type="text"
            step="any"
            placeholder="0"
            className={`form-control ${!!errors?.shelfLifeDays && "is-invalid"}`}
            disabled={disabled}
          />
          {!!errors?.shelfLifeDays && (
            <span className="error-message">
              {errors?.shelfLifeDays?.message || "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="maxDispatchDays" className="form-label">
            Plazo máximo para despachar (días)
          </label>
          <input
            {...register("maxDispatchDays", {
              pattern: {
                value: REGEX.NUMERIC,
                message: "Ingrese un número válido",
              },
              validate: {
                greaterThanZero: (value) => {
                  if (!value) return true;
                  return Number(value) > 0 || "El valor debe ser mayor que 0";
                },
                lessThanShelfLife: (value) => {
                  if (!value || !shelfLifeDays) return true;
                  return (
                    Number(value) < Number(shelfLifeDays) ||
                    "Debe ser menor que la vida útil"
                  );
                },
              },
            })}
            id="maxDispatchDays"
            type="text"
            step="any"
            placeholder="0"
            className={`form-control ${!!errors?.maxDispatchDays && "is-invalid"}`}
            disabled={disabled}
          />
          {!!errors?.maxDispatchDays && (
            <span className="error-message">
              {errors?.maxDispatchDays?.message || "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
      </Row>
    </Container>
  );
};
